import React from "react";
import { getFullUrlPath } from "../../../utils";
import { mainNavigationDefaultData } from "../defaultData";
import styles from "./MainNavigation.module.scss";
import { NavigationItem } from "./NavigationItem";
const NONE = "none";
const NOT_SET = "(not set)";
const createAnalyticsData = (child, parent, level) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    return Object.assign(Object.assign({ event: "visitor interaction", interactionName: "navigation click", linkType: "primary nav", linkRootPosition: ((_b = (_a = parent === null || parent === void 0 ? void 0 : parent.parent) === null || _a === void 0 ? void 0 : _a.parent) === null || _b === void 0 ? void 0 : _b.position) ||
            ((_c = parent === null || parent === void 0 ? void 0 : parent.parent) === null || _c === void 0 ? void 0 : _c.position) ||
            (parent === null || parent === void 0 ? void 0 : parent.position) ||
            (child === null || child === void 0 ? void 0 : child.position), linkRootText: (((_e = (_d = parent === null || parent === void 0 ? void 0 : parent.parent) === null || _d === void 0 ? void 0 : _d.parent) === null || _e === void 0 ? void 0 : _e.name) ||
            ((_f = parent === null || parent === void 0 ? void 0 : parent.parent) === null || _f === void 0 ? void 0 : _f.name) ||
            (parent === null || parent === void 0 ? void 0 : parent.name) ||
            (child === null || child === void 0 ? void 0 : child.name) ||
            "").toLowerCase(), linkPosition: NONE, linkPositionText: NONE, linkSubPosition: NONE, linkSubPositionText: NONE, linkUrl: getFullUrlPath((child === null || child === void 0 ? void 0 : child.url) || (parent === null || parent === void 0 ? void 0 : parent.url) || "") }, (level === 2
        ? {
            linkPosition: child === null || child === void 0 ? void 0 : child.position,
            linkPositionText: (_g = child === null || child === void 0 ? void 0 : child.name) === null || _g === void 0 ? void 0 : _g.toLowerCase(),
        }
        : {})), (level === 3
        ? {
            linkPosition: parent === null || parent === void 0 ? void 0 : parent.position,
            linkPositionText: ((_h = parent === null || parent === void 0 ? void 0 : parent.name) === null || _h === void 0 ? void 0 : _h.toLowerCase()) || NOT_SET,
            linkSubPosition: child === null || child === void 0 ? void 0 : child.position,
            linkSubPositionText: (_j = child === null || child === void 0 ? void 0 : child.name) === null || _j === void 0 ? void 0 : _j.toLowerCase(),
        }
        : {}));
};
const RenderMenu = (children = [], level = 1, setMenuOpen, isMainMenuOpen, analytics) => children.map((child) => (<NavigationItem key={child.name} child={child} level={level} setMenuOpen={setMenuOpen} analytics={analytics} isMainMenuOpen={isMainMenuOpen}/>));
export const MainNavigation = ({ analytics = (data) => data, setMenuOpen, isMainMenuOpen, }) => {
    const decorate = (menus = [], parent, level = 1) => {
        return menus.map((menu, index) => {
            const decoratedMenu = Object.assign(Object.assign({}, menu), { position: index + 1, parent, onClick: () => {
                    analytics(createAnalyticsData(Object.assign(Object.assign({}, menu), { position: index + 1, parent }), parent, level));
                } });
            if (menu.tabmenu) {
                return Object.assign(Object.assign({}, decoratedMenu), { tabmenu: decorate(menu.tabmenu, decoratedMenu, level) });
            }
            if (menu.curtainMenu) {
                return Object.assign(Object.assign({}, decoratedMenu), { 
                    // increase level by one to trick analyticsData
                    curtainMenu: decorate(menu.curtainMenu, decoratedMenu, level + 1) });
            }
            if (menu.submenu) {
                return Object.assign(Object.assign({}, decoratedMenu), { submenu: decorate(menu.submenu, decoratedMenu, level + 1) });
            }
            return decoratedMenu;
        });
    };
    const navDataWithAnalytics = decorate(mainNavigationDefaultData, {});
    return (<nav className={styles.container}>
      <div className={styles.menu}>
        {RenderMenu(navDataWithAnalytics, 1, setMenuOpen, isMainMenuOpen, analytics)}
      </div>
    </nav>);
};
